import { RouterProvider } from '@rocketlane/rocket-router';
import ReactDOM from 'react-dom/client';
import { router } from 'routes/app-routes';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<RouterProvider router={router} />);
